import { render, staticRenderFns } from "./RequestAQuote.vue?vue&type=template&id=6e81f345"
import script from "./RequestAQuote.vue?vue&type=script&lang=js"
export * from "./RequestAQuote.vue?vue&type=script&lang=js"
import style0 from "./RequestAQuote.vue?vue&type=style&index=0&id=6e81f345&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wedevs/Herd/dokan-core/wp-content/plugins/dokan-pro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e81f345')) {
      api.createRecord('6e81f345', component.options)
    } else {
      api.reload('6e81f345', component.options)
    }
    module.hot.accept("./RequestAQuote.vue?vue&type=template&id=6e81f345", function () {
      api.rerender('6e81f345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/request-for-quotation/assets/src/js/admin/pages/RequestAQuote.vue"
export default component.exports